import globalDomains from '@/utils/global-domains';
import {PHPApiCore, NODEApiCore} from '@/api';

const PHP_BASE_URL = `${globalDomains.BJAPI_AFREECATV}/api`;
const PHP_BASE_URL_ST = `${globalDomains.ST_AFREECATV}/api`;
const PHP_BASE_URL_STBBS = `${globalDomains.STBBS_AFREECATV}/api`;
const PHP_BASE_URL_STBBS_APP = `${globalDomains.STBBS_AFREECATV}`;
const PHP_BASE_URL_LIVE = `${globalDomains.LIVE_AFREECATV}/api`;
const PHP_BASE_URL_SEARCH = `${globalDomains.SCH_AFREECATV}`;
const NODE_BASE_URL = `${globalDomains.API_CHANNEL_AFREECATV}/v1.1/channel`;
const EVENT_API_BASE_URL = `${globalDomains.EVENTAPI_AFREECATV}`;
const AFEVENT2_BASE_URL = `${globalDomains.AFEVENT2_AFREECATV}`;

export const STATION_API_TIMEOUT = 30000;

export const PHPCommonApi = PHPApiCore(
  PHP_BASE_URL,
  undefined,
  undefined,
  undefined,
  undefined,
  undefined,
  STATION_API_TIMEOUT,
);
export const PHPCommonApiWithFormData = PHPApiCore(
  PHP_BASE_URL,
  undefined,
  undefined,
  undefined,
  undefined,
  false,
  STATION_API_TIMEOUT,
);
export const NODECommonApi = NODEApiCore(
  NODE_BASE_URL,
  undefined,
  undefined,
  undefined,
  undefined,
  false,
  STATION_API_TIMEOUT,
);
export const STCommonApi = PHPApiCore(
  PHP_BASE_URL_ST,
  undefined,
  undefined,
  undefined,
  undefined,
  false,
  STATION_API_TIMEOUT,
);

export const LIVECommonApi = PHPApiCore(
  PHP_BASE_URL_LIVE,
  undefined,
  undefined,
  undefined,
  undefined,
  false,
  STATION_API_TIMEOUT,
);

export const SearchCommentApi = PHPApiCore(
  PHP_BASE_URL_SEARCH,
  undefined,
  undefined,
  undefined,
  undefined,
  false,
  STATION_API_TIMEOUT,
);

export const STBBSCommonApi = PHPApiCore(
  PHP_BASE_URL_STBBS,
  undefined,
  undefined,
  undefined,
  undefined,
  false,
);

export const STBBSAppApi = PHPApiCore(
  PHP_BASE_URL_STBBS_APP,
  undefined,
  undefined,
  undefined,
  undefined,
  false,
  STATION_API_TIMEOUT,
);

export const LOGEVENTCommonApi = PHPApiCore(
  EVENT_API_BASE_URL,
  undefined,
  undefined,
  undefined,
  undefined,
  false,
  STATION_API_TIMEOUT,
);

export const AFEVENT2CommonApi = PHPApiCore(
  AFEVENT2_BASE_URL,
  undefined,
  undefined,
  undefined,
  undefined,
  false,
  STATION_API_TIMEOUT,
);
